import dayjs from 'dayjs';

import type { GridFilterModel } from '@packages/fenrir/components';
// import { getUnixTimestamp } from '@packages/utils/date-time-functions/date-time-functions';

// Fixtures to validate and convert the values of filter parameters to required formats by the API.
export const getStringArray = (value: string | string[] | undefined) => {
  return value && value.length > 0 ? value : undefined;
};

export const getString = (value: string | string[]) => {
  return value ? value : undefined;
};

export const getDateValue = (value: string | string[]) => {
  if (Array.isArray(value)) value = value[0];
  return dayjs(value).isValid() ? dayjs(value) : undefined;
};

export const getDateArray = (value: string | string[] | undefined) => {
  if (Array.isArray(value) && value.length > 0)
    return value.map((date) => dayjs(date));
  return undefined;
};

/**
 * Retrieves the value of a filter parameter from the filter model.
 *
 * @param field - The field name to search for in the filter model.
 * @param params - The filter model containing filter items.
 * @param operator - (Optional) The operator to match in the filter item.
 * @returns The value of the filter parameter if found, or `undefined`.
 */
export const getParam = (
  field: string,
  params: GridFilterModel,
  operator?: string,
) => {
  return params.items.find((p) => {
    if (operator && p.operator !== operator) return false;
    return p.field === field;
  })?.value;
};
